"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("api/documents/purchases/procurementCorrections/types");
const parsers_1 = require("api/documents/purchases/procurementCorrections/parsers");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const SelectField_1 = tslib_1.__importDefault(require("src/components/selects/SelectField"));
const ReasonsSelectField = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const validateReasons = props.reasons.some(el => {
        return Number(el.id) === types_1.ReasonTypes.BILATERAL_TERMINATION_OF_CONTRACT
            || Number(el.id) === types_1.ReasonTypes.UNILATERAL_TERMINATION_OF_CONTRACT;
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: 'col-sm-4 col-xs-12 d-flex', children: (0, jsx_runtime_1.jsxs)("div", { className: 'form-group align-self-end w-100 p-0', children: [(0, jsx_runtime_1.jsx)("label", { className: 'form-control-label', children: translate('reasonChange', 'ცვლილების მიზეზი') }), (0, jsx_runtime_1.jsx)(SelectField_1.default, { name: 'reasons', value: null, onChange: (_name, value) => {
                        if (!props.reasons.find(el => el.id === value.id)) {
                            const reasonId = Number(value.id);
                            if (reasonId === types_1.ReasonTypes.UNILATERAL_TERMINATION_OF_CONTRACT
                                || reasonId === types_1.ReasonTypes.BILATERAL_TERMINATION_OF_CONTRACT) {
                                props.setFieldValue('reasons', [value]);
                            }
                            else {
                                props.setFieldValue('reasons', [...props.reasons, value]);
                            }
                        }
                    }, options: parsers_1.correctionReasons, disabled: validateReasons })] }) }));
};
exports.default = ReasonsSelectField;
